import OWContainer from 'styles/styled-components/ow-container';
import { MaterialReactTable } from 'material-react-table';
import useController from '../controllers/orders-controller';
import { Box, Typography } from '@mui/material';
import TableTabs from 'components/controls/table-tabs';
import { ResponsePlaceDto } from 'features/place/types/dtos';
import React from 'react';

export const OrdersRoute = () => {
    const { tableSettings, placeId, activePlace, handleTabChange, places } = useController();

    if (places?.content.length === 0) {
        return (
            <Box>
                <Typography>This website has no places</Typography>
            </Box>
        );
    }

    return (
        <React.Fragment>
            {placeId !== '' && (
                <TableTabs<ResponsePlaceDto>
                    active={!!activePlace}
                    id={placeId}
                    handleTabChange={handleTabChange}
                    tabData={places?.content}
                    renderAdd={false}
                >
                    {activePlace && (
                        <OWContainer>
                            <MaterialReactTable table={tableSettings} />
                        </OWContainer>
                    )}
                </TableTabs>
            )}
        </React.Fragment>
    );
};
